module.exports = __webpack_public_path__ + "media/images/photo/features/money-1ebd8d5cc787b16ccce831e5986da43a.svg";